import AccountNumbersForm, {
  type AccountNumberValues,
} from "../Compta/AccountNumbersForm";
import type { Property } from "../../models/property";

const RENT_CATALOGUE_ACCOUNT = "708213";
const CHARGES_CATALOGUE_ACCOUNT = "708214";

interface PropertyAccountingFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  property: Property;
  updateProperty: (
    propertyId: number,
    values: AccountNumberValues,
  ) => Promise<unknown>;
}

export default function PropertyAccountingForm({
  open,
  onOpenChange,
  property,
  updateProperty,
}: PropertyAccountingFormProps) {
  return (
    <AccountNumbersForm
      open={open}
      onOpenChange={onOpenChange}
      header="Comptes du bien dans votre comptabilité"
      subtitle="Comptes de produit repris dans l'export FEC du bailleur pour les appels de ce bien. Laissez vide pour garder les comptes du catalogue. Les comptes client et de dépôt de garantie se règlent sur chaque bail."
      fields={[
        {
          name: "rent_revenue_account",
          label: "Compte de produit des loyers",
          placeholder: RENT_CATALOGUE_ACCOUNT,
        },
        {
          name: "charges_revenue_account",
          label: "Compte de produit des charges locatives",
          placeholder: CHARGES_CATALOGUE_ACCOUNT,
        },
      ]}
      initialValues={{
        rent_revenue_account: property.rent_revenue_account ?? null,
        charges_revenue_account: property.charges_revenue_account ?? null,
      }}
      onSubmit={async (values: AccountNumberValues) => {
        await updateProperty(property.id, values);
      }}
    />
  );
}
